/**
 * Circular avatar image component that maps an avatar identifier to one of 24 preset images.
 *
 * @module components/common/CharacterAvatar
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import PropTypes from 'prop-types';
import avatar1 from '../../assets/images/avatars/avatar-1.png';
import avatar2 from '../../assets/images/avatars/avatar-2.png';
import avatar3 from '../../assets/images/avatars/avatar-3.png';
import avatar4 from '../../assets/images/avatars/avatar-4.png';
import avatar5 from '../../assets/images/avatars/avatar-5.png';
import avatar6 from '../../assets/images/avatars/avatar-6.png';
import avatar7 from '../../assets/images/avatars/avatar-7.png';
import avatar8 from '../../assets/images/avatars/avatar-8.png';
import avatar9 from '../../assets/images/avatars/avatar-9.png';
import avatar10 from '../../assets/images/avatars/avatar-10.png';
import avatar11 from '../../assets/images/avatars/avatar-11.png';
import avatar12 from '../../assets/images/avatars/avatar-12.png';
import avatar13 from '../../assets/images/avatars/avatar-13.png';
import avatar14 from '../../assets/images/avatars/avatar-14.png';
import avatar16 from '../../assets/images/avatars/avatar-16.png';
import avatar17 from '../../assets/images/avatars/avatar-17.png';
import avatar18 from '../../assets/images/avatars/avatar-18.png';
import avatar19 from '../../assets/images/avatars/avatar-19.png';
import avatar15 from '../../assets/images/avatars/avatar-15.png';
import avatar20 from '../../assets/images/avatars/avatar-20.png';
import avatar21 from '../../assets/images/avatars/avatar-21.png';
import avatar22 from '../../assets/images/avatars/avatar-22.png';
import avatar23 from '../../assets/images/avatars/avatar-23.png';
import avatar24 from '../../assets/images/avatars/avatar-24.png';

/**
 * A component that renders a circular avatar image based on the provided avatar type.
 * The image displayed corresponds to a pre-defined avatar identifier. The output avatar
 * can have a customizable border color and additional custom CSS classes.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.avatar - The identifier for the avatar to render. Expected values are strings
 *                                such as 'avatar-1', 'avatar-2', ..., up to 'avatar-24'. If an unknown
 *                                or undefined value is provided, 'avatar-1' will be the default.
 * @param {string} props.borderColor - A string representing the border color of the avatar,
 *                                     applied as a 1px solid border around the image.
 * @param {string} props.classes - Additional CSS classes to be applied to the avatar for customizing
 *                                 styling. This string should contain a valid list of class names.
 *
 * @returns {JSX.Element} A JSX element representing a circular avatar image with optional border color
 *                        and custom classes applied.
 */
const CharacterAvatar = ({
    avatar,
    borderColor,
    classes,
}) => {
    let pic;
    switch (avatar) {
        case 'avatar-2':
            pic = avatar2;
            break;
        case 'avatar-3':
            pic = avatar3;
            break;
        case 'avatar-4':
            pic = avatar4;
            break;
        case 'avatar-5':
            pic = avatar5;
            break;
        case 'avatar-6':
            pic = avatar6;
            break;
        case 'avatar-7':
            pic = avatar7;
            break;
        case 'avatar-8':
            pic = avatar8;
            break;
        case 'avatar-9':
            pic = avatar9;
            break;
        case 'avatar-10':
            pic = avatar10;
            break;
        case 'avatar-11':
            pic = avatar11;
            break;
        case 'avatar-12':
            pic = avatar12;
            break;
        case 'avatar-13':
            pic = avatar13;
            break;
        case 'avatar-14':
            pic = avatar14;
            break;
        case 'avatar-15':
            pic = avatar15;
            break;
        case 'avatar-16':
            pic = avatar16;
            break;
        case 'avatar-17':
            pic = avatar17;
            break;
        case 'avatar-18':
            pic = avatar18;
            break;
        case 'avatar-19':
            pic = avatar19;
            break;
        case 'avatar-20':
            pic = avatar20;
            break;
        case 'avatar-21':
            pic = avatar21;
            break;
        case 'avatar-22':
            pic = avatar22;
            break;
        case 'avatar-23':
            pic = avatar23;
            break;
        case 'avatar-24':
            pic = avatar24;
            break;
        case 'avatar-1':
        default:
            pic = avatar1;
    }

    return (
        <Avatar variant="circular"
                className={classes}
                src={pic}
                alt="alt"
                style={{ border: `1px solid ${borderColor}` }}
        />
    );
    //return pic;
};

CharacterAvatar.propTypes = {
    avatar: PropTypes.string,
    borderColor: PropTypes.string,
    classes: PropTypes.string,
    alt: PropTypes.string,
};

export default CharacterAvatar;
